var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 0C37.2533 0 48 10.7467 48 24C48 37.2533 37.2533 48 24 48C10.7467 48 0 37.2533 0 24C0 10.7467 10.7467 0 24 0ZM24 5.33333C13.6907 5.33333 5.33333 13.6907 5.33333 24C5.33333 34.3093 13.6907 42.6667 24 42.6667C34.3093 42.6667 42.6667 34.3093 42.6667 24C42.6667 13.6907 34.3093 5.33333 24 5.33333ZM24 10.6667C25.472 10.6667 26.6667 11.5813 26.6667 16V22.248C26.6667 23.3387 26.6667 23.8827 26.8693 24.3733C27.072 24.864 27.456 25.248 28.2293 26.0187L30.1147 27.904C33.2373 31.0293 33.0427 32.52 32 33.5627C30.96 34.6027 29.4667 34.8 26.344 31.6773L24.4587 29.792C22.9173 28.248 22.144 27.48 21.7387 26.4987C21.408 25.6987 21.3467 24.8187 21.336 23.336L21.3333 16C21.3333 11.5813 22.528 10.6667 24 10.6667Z",
  fill: "#091F5A"
});

function SvgOneShotPlanned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneShotPlanned);
export default __webpack_public_path__ + "static/media/one_shot_planned.d63a4fe2.svg";
export { ForwardRef as ReactComponent };